module.exports = __webpack_public_path__ + "latvia.svg?e071341772f5a45b34a0dfe55f981c8b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/latvia.svg
// module id = 210
// module chunks = 10